const CptName = 'ComBlockQuote'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      children: []
    },
    cpt: CptName
  }
}

export default {
  name: 'blockquote',
  formatData
}